module.exports = __webpack_public_path__ + "img/ability.a1de93cf.png";